import { Directive } from 'vue';

const vFocus: Directive<HTMLElement, boolean> = {
  mounted(el, binding) {
    if (binding.value) {
      el.focus();
    }
  },
  updated(el, binding) {
    if (binding.value) {
      el.focus();
    }
  }
};

export default vFocus;
